'use strict';

import FastClick from 'fastclick';

const saFastclick = [
  function () {
    return {
      link: function ($scope, $element) {
        FastClick.attach($element[0]);
      }
    };
  }
];

export default saFastclick;



// WEBPACK FOOTER //
// ./app/src/directives/fastclick.js